import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'
import { FETCH_TUTOR_FAIL, FETCH_TUTOR_SUCCESS } from './tutorReducer'

export interface AuthReducer {
  authState: 'initial' | 'authorized' | 'notAuthorized'
  submitError: boolean
  isLoading: boolean
  showResetPasswordEmailModal: boolean
}

const initialState: AuthReducer = {
  authState: 'initial',
  submitError: false,
  isLoading: false,
  showResetPasswordEmailModal: false
}

export const SIGN_IN = createAction<SignInPayload>('auth_reducer/sign_in')
export const SIGN_IN_FAIL = createAction('auth_reducer/sign_in_error')
export const SIGN_IN_SUCCESS = createAction('auth_reducer/sign_in_success')

interface SendResetPasswordEmailPayload {
  email: string
}
export type SendResetPasswordEmailActionType = PayloadAction<SendResetPasswordEmailPayload>
export const SEND_RESET_PASSWORD_EMAIL = createAction<SendResetPasswordEmailPayload>(
  'auth_reducer/send_reset_password_email'
)
export const SEND_RESET_PASSWORD_EMAIL_SUCCESS = createAction('auth_reducer/send_reset_password_email_success')
export const SEND_RESET_PASSWORD_EMAIL_FAIL = createAction('auth_reducer/send_reset_password_email_fail')
export const SET_SHOW_RESET_PASSWORD_EMAIL_MODAL = createAction<boolean>(
  'auth_reducer/set_show_reset_password_email_modal'
)

interface SetNewPasswordPayload {
  secureId: string
  password: string
}
export type SetNewPasswordActionType = PayloadAction<SetNewPasswordPayload>
export const SET_NEW_PASSWORD = createAction<SetNewPasswordPayload>('auth_reducer/set_new_password')
export const SET_NEW_PASSWORD_SUCCESS = createAction('auth_reducer/set_new_password_success')
export const SET_NEW_PASSWORD_FAIL = createAction('auth_reducer/set_new_password_fail')

interface SignInPayload {
  email: string
  password: string
}
export type SignInActionType = PayloadAction<SignInPayload>

export const authReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SIGN_IN, (state) => {
      return { ...state, isLoading: true }
    })
    .addCase(SIGN_IN_FAIL, (state) => {
      return { ...state, submitError: true, isLoading: false }
    })
    .addCase(SIGN_IN_SUCCESS, (state) => {
      return { ...state, submitError: false, isLoading: false }
    })
    .addCase(FETCH_TUTOR_SUCCESS, (state) => {
      return { ...state, authState: 'authorized' }
    })
    .addCase(FETCH_TUTOR_FAIL, (state) => {
      return { ...state, authState: 'notAuthorized' }
    })
    .addCase(SEND_RESET_PASSWORD_EMAIL_SUCCESS, (state) => {
      return { ...state, showResetPasswordEmailModal: true }
    })
    .addCase(SET_SHOW_RESET_PASSWORD_EMAIL_MODAL, (state, action) => {
      return { ...state, showResetPasswordEmailModal: action.payload }
    })
})
